export const SET_VENDOR_PAYMENT = "SET_VENDOR_PAYMENT";
export const SET_SPECIFIC_VENDOR_PAYMENT = "SET_SPECIFIC_VENDOR_PAYMENT";
export const RESET_SPECIFIC_VENDOR_PAYMENT = "RESET_SPECIFIC_VENDOR_PAYMENT";